export default '/profiles/@slug'
